import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/stores`;
export const API_URL_USER = `${process.env.REACT_APP_API_URL}/stores/users`;

// CREATE =>  POST: add a new product to the server
export function createStore(store) {
    return axios.post(API_URL, { ...store });
}

// READ
export function getAllStores() {
    return axios.get(API_URL);
}

export function getPaginatedStores(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getStoreById(storeId) {
    return axios.get(`${API_URL}/${storeId}`);
}

export function createUser(user) {
    return axios.post(`${API_URL_USER}`, { ...user })
}


// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the store on the server
export function updateStore(storeId, store) {
    return axios.put(`${API_URL}/${storeId}`, { ...store });
}


// DELETE => delete the product from the server
export function deleteStore(storeId) {
    return axios.delete(`${API_URL}/${storeId}`);
}
